// Built-ins
import React from "react";

// Modules / Functions
import axios from "axios";
import { Card } from "react-bootstrap";
import { Grid } from "semantic-ui-react";
import Swal from "sweetalert2";

// Icons / Images
import { BsInfoSquare } from "react-icons/bs";
import { MdBlock } from "react-icons/md";

import { MdOutlineSupportAgent } from "react-icons/md"; // Charter Broker
import { GiPlaneWing } from "react-icons/gi";
import { BsCalendarDate } from "react-icons/bs";

// Custom Made Components
import DeleteObjectModal from "../../../modals/delete_object";
import ChangeYear from "../../../modals/aircrafts/change_year";
import { AIRCRAFT_PREVIEW_IMAGES } from "../aircraft_preview_urls";

// Global Variables
import {
  headers,
  loader,
  pageHeader,
  forbidden,
  restrictedUsers,
} from "../../../global_vars";

// Variables
window.Swal = Swal;

let overviewIconStyle = { color: "#F3702D", marginRight: "0.5em" };

const VIEW_AIRCRAFT = "https://groupplan.gr/api/data_management/aircraft/";

function getAircraftId() {
  return window.location.pathname.split("/")[3];
}

class AircraftOverView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      aircraft: {
        notes: {},
      },
      charter_broker: "",
      is_loaded: false,
      previewImageFailed: false,
    };
    this.refresh = this.refresh.bind(this);
  }

  componentDidMount() {
    if (restrictedUsers().includes(localStorage.getItem("user"))) {
      this.setState({
        forbidden: true,
      });
    }
    headers["Authorization"] = "Token " + localStorage.getItem("userToken");
    axios
      .get(VIEW_AIRCRAFT + getAircraftId(), {
        headers: headers,
      })
      .then((res) => {
        this.setState({
          aircraft: res.data.aircraft,
          charter_broker: res.data.charter_broker,
          notes: res.data.aircraft.notes,
          is_loaded: true,
        });
      })
      .catch((e) => {
        if (e.response.status === 401) {
          this.setState({
            forbidden: true,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An unknown error has occured.",
          });
        }
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.aircraft.model !== this.state.aircraft.model) {
      this.setState({ previewImageFailed: false });
    }
  }

  update_notes = (notes) => {
    var aircraft = { ...this.state.aircraft };
    aircraft.notes = notes;
    this.setState({
      aircraft: aircraft,
    });
  };

  update_state = (update_state) => {
    this.setState({ aircraft: update_state });
  };

  refresh = () => {
    headers["Authorization"] = "Token " + localStorage.getItem("userToken");
    axios
      .get(VIEW_AIRCRAFT + getAircraftId(), {
        headers: headers,
      })
      .then((res) => {
        this.setState({
          aircraft: res.data.aircraft,
          charter_broker: res.data.charter_broker,
          notes: res.data.aircraft.notes,
          is_loaded: true,
        });
      });
  };

  update_aircraft_op = (charter_broker) => {
    this.setState({ charter_broker: charter_broker });
  };

  render() {
    return (
      <>
        <div className="mainContainer">
          {pageHeader("aircraft_overview", this.state.aircraft.model)}
          {this.state.forbidden ? (
            <>{forbidden("Aircraft Overview")}</>
          ) : this.state.is_loaded ? (
            <>
              <Grid stackable columns={2} divided>
                <Grid.Column>
                  <Card>
                    <Card.Header>
                      <BsInfoSquare
                        style={{
                          color: "#F3702D",
                          fontSize: "1.5em",
                          marginRight: "0.5em",
                        }}
                      />
                      Aircraft Information
                    </Card.Header>
                    <Card.Body>
                      <div className={"info_descr"}>
                        <MdOutlineSupportAgent style={overviewIconStyle} />
                        Charter Broker
                      </div>
                      <div className={"info_span"}>
                        {this.state.aircraft.charter_broker ? this.state.aircraft.charter_broker.name : "N/A"}
                      </div>
                      <MdBlock
                        title={"Aircraft's Charter Broker cannot be changed"}
                        style={{
                          color: "red",
                          fontSize: 16,
                          float: "right",
                          marginTop: 5,
                          cursor: "unset",
                        }}
                        className={"edit_icon"}
                      />
                      <div className={"info_descr"}>
                        <GiPlaneWing style={overviewIconStyle} /> Model
                      </div>
                      <div className={"info_span"}>
                        {this.state.aircraft.model ? this.state.aircraft.model : "N/A"}
                      </div>
                      <MdBlock
                        title={"Aircraft's Model cannot be changed"}
                        style={{
                          color: "red",
                          fontSize: 16,
                          float: "right",
                          marginTop: 5,
                          cursor: "unset",
                        }}
                        className={"edit_icon"}
                      />
                      <div className={"info_descr"}>
                        <BsCalendarDate style={overviewIconStyle} /> Year
                      </div>
                      <div className={"info_span"}>
                        {this.state.aircraft.year ? this.state.aircraft.year : "N/A"}
                      </div>
                      <ChangeYear
                        aircraft_id={this.state.aircraft.id}
                        update_state={this.update_state}
                        year={this.state.aircraft.year ? this.state.aircraft.year : ""}
                      />
                    </Card.Body>
                    <Card.Footer>
                      <DeleteObjectModal
                        object_id={this.state.aircraft.id}
                        object_name={this.state.aircraft.model}
                        object_type={"Aircraft"}
                        update_state={this.update_state}
                      />
                    </Card.Footer>
                  </Card>
                </Grid.Column>
                <Grid.Column width={5}>
                  <Card>
                    <Card.Header>
                      <BsInfoSquare
                        style={{
                          color: "#F3702D",
                          fontSize: "1.5em",
                          marginRight: "0.5em",
                        }}
                      />
                      Aircraft's Model Image
                    </Card.Header>
                    <Card.Body>
                    {AIRCRAFT_PREVIEW_IMAGES[this.state.aircraft.model] && (
                      <img
                        src={
                          this.state.previewImageFailed
                            ? `https://placehold.co/480x300/2d2d2d/F3702D/png?text=${encodeURIComponent(
                                this.state.aircraft.model || "Aircraft"
                              )}`
                            : AIRCRAFT_PREVIEW_IMAGES[this.state.aircraft.model]
                        }
                        alt={this.state.aircraft.model}
                        style={{ width: "400px", margin: 20, height: "auto" }}
                        onError={() =>
                          this.setState({ previewImageFailed: true })
                        }
                      />
                    )}
                    </Card.Body>
                    <Card.Footer>
                    </Card.Footer>
                  </Card>
                </Grid.Column>
              </Grid>
            </>
          ) : (
            loader()
          )}
        </div>
      </>
    );
  }
}

export default AircraftOverView;
